import React from 'react'

type Props = {
  requestedEntity: any
}

const RequestedEntityInfo: React.FC<Props> = ({ requestedEntity }) => {
  return (
    <div className="bg-gray-100 p-4 rounded shadow">
      <h2 className="text-xl font-semibold mb-2">Requested Entity Info</h2>
      <p>
        <strong>Custom Input:</strong> {requestedEntity.customInput}
      </p>
      <p>
        <strong>Context String:</strong> {requestedEntity.assignedContextString}
      </p>
    </div>
  )
}

export default RequestedEntityInfo
